export const getSafeString = (value) => value || '';

export const getKeyCode = (e) => {
  return e.which || e.keyCode;
};

export const getTargetValue = (e) => {
  return e.target && getSafeString(e.target.value);
};

export const isEnterKey = (e) => {
  return getKeyCode(e) === 13;
};
